import { gsap } from 'gsap';

const toggleBtn = document.querySelector('.navigation-toggle');
const nav = document.querySelector('#main-navigation');
const overlay = document.querySelector('#navigation-overlay');

// Overlay immer initial verstecken, unabhängig von toggleBtn/nav
if (overlay) gsap.set(overlay, { autoAlpha: 0 });

// closeNav wird auch von modal.js genutzt – daher als modul-globale Variable
let closeNav = () => {};

if (toggleBtn && nav) {
  // Nav initial verstecken und aus Tab-Reihenfolge entfernen
  gsap.set(nav, { autoAlpha: 0, y: 0 });
  nav.setAttribute('inert', '');

  const openNav = () => {
    nav.removeAttribute('inert');
    // pointer-events aktivieren damit Touch-Scroll auf dem Nav-Container funktioniert (iOS Safari Fix)
    nav.style.pointerEvents = 'auto';
    gsap.to(nav, { autoAlpha: 1, y: 0, duration: 0.3, ease: 'power2.inOut' });
    if (overlay) gsap.to(overlay, { autoAlpha: 1, duration: 0.3 });
    toggleBtn.setAttribute('aria-expanded', 'true');

    // iOS Safari Body-Lock: position:fixed verhindert Scroll-Freeze auf dem inneren Element
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.dataset.scrollY = scrollY;
  };

  closeNav = () => {
    gsap.to(nav, { autoAlpha: 0, y: 0, duration: 0.2, ease: 'power2.inOut' });
    if (overlay) gsap.to(overlay, { autoAlpha: 0, duration: 0.2 });
    toggleBtn.setAttribute('aria-expanded', 'false');
    nav.setAttribute('inert', '');
    // pointer-events wieder deaktivieren
    nav.style.pointerEvents = 'none';

    // Scroll-Position nach Body-Lock wiederherstellen
    const scrollY = parseInt(document.body.dataset.scrollY || '0', 10);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    delete document.body.dataset.scrollY;
    window.scrollTo(0, scrollY);
  };

  const isOpen = () => gsap.getProperty(nav, 'autoAlpha') > 0;

  // Toggle bei Klick auf Button
  toggleBtn.addEventListener('click', () => {
    isOpen() ? closeNav() : openNav();
  });

  // Click auf Overlay schließt Navigation
  if (overlay) overlay.addEventListener('click', closeNav);

  // Schließen bei Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) {
      closeNav();
      toggleBtn.focus();
    }
  });
}

// Mobile Toggle für [data-nav-mobile-toggle] – unabhängig von Haupt-Navigation
document.querySelectorAll('[data-nav-mobile-toggle]').forEach(btn => {
  const targetId = btn.getAttribute('aria-controls');
  const target = targetId ? document.getElementById(targetId) : null;
  if (!target) return;

    btn.addEventListener('click', () => {
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isExpanded));
      target.classList.toggle('max-lg:hidden', isExpanded);
    });
});

export { closeNav };
